import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
	root: {
		minWidth: 110
	},
	itemText: {
		paddingLeft: 10
	}
});
